import React from "react";
import {autobind} from "core-decorators";
import {Modal} from "antd";
import {inject, observer} from "mobx-react";

import Store from "@/stores";
import UpgradeSubscription from "./UpgradeSubscription";

export interface IAddPieceUpgradeModalProps {
  close: () => void;
  store?: Store;
  visible: boolean;
}

@inject("store")
@autobind
@observer
export default class AddPieceUpgradeModal extends React.Component<IAddPieceUpgradeModalProps> {
  public render() {
    const {session} = this.props.store!;
    return (
      <Modal
        title="Add Piece"
        open={this.props.visible}
        cancelText="Close"
        onOk={this.props.close}
        onCancel={this.props.close}
        okButtonProps={{style: {display: "none"}}}
      >
        <p>
          Adding custom pieces is only available for conductors of ensembles whose owner is subscribed to a Pro or
          Ensemble plan.
        </p>
        {session.isEnsembleOwner ? (
          <div style={{display: "flex", justifyContent: "center"}}>
            <UpgradeSubscription plan="Pro" onClick={this.props.close} />
          </div>
        ) : (
          <p>
            Since you are not the owner of the currently selected ensemble ({session.selectedEnsemble?.name}
            ), you should contact the owner to upgrade his/her account.
          </p>
        )}
      </Modal>
    );
  }
}
